import { render } from "./check.vue?vue&type=template&id=251d9252"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"

import "./check.vue?vue&type=style&index=0&id=251d9252&lang=less"
script.render = render

export default script